import React, { Component } from 'react'
import moment from 'moment'

import {
  Segment,
  DatePicker,
  Grid,
  Chart,
} from 'components/UI'

import BuildingTimeline from './BuildingTimeline'
import BuildingCharts from './BuildingCharts'
import BuildingStats from './BuildingStats'

export default class Building extends Component {
  constructor (props) {
    super(props)
    this.state = {
      timelineFrom: moment().subtract(1, 'day').valueOf(),
      timelineTo: moment().valueOf(),
      selectedResource: 'units',
    }
  }

  handleTimelineDateChange = range => {
    // valueOf gets the milliseconds since epoch
    this.setState({
      timelineFrom: range.startDate.valueOf(),
      timelineTo: range.endDate.valueOf(),
    })
  }

  handleTabClick (name) {
    this.setState({
      selectedResource: name,
    })
  }

  handleTimelineZoom = (timelineFrom, timelineTo) => {
    this.setState({
      timelineFrom: parseInt(timelineFrom, 10),
      timelineTo: parseInt(timelineTo, 10),
    })
  }

  render () {
    const { buildingId } = this.props.match.params
    const {
      selectedResource,
      timelineTo,
      timelineFrom,
    } = this.state

    return (
      <Grid>
        <BuildingStats
          buildingId={buildingId}
          selectedResource={selectedResource}
        />
        <BuildingCharts
          buildingId={buildingId}
          onFloorClick={() => this.handleTabClick('units')}
          onLineClick={() => this.handleTabClick('lines')}
          history={this.props.history}
        />
        <Grid.Row>
          <Grid.Col>
            <Segment centered>
              <Chart.LineTitle title='Average Building Temperatures' />
              <DatePicker
                onChange={this.handleTimelineDateChange}
                from={timelineFrom}
                to={timelineTo}
              />
              <BuildingTimeline
                buildingId={buildingId}
                from={timelineFrom}
                to={timelineTo}
                onZoom={this.handleTimelineZoom}
              />
            </Segment>
          </Grid.Col>
        </Grid.Row>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Building/Building.jsx